export default import.meta.ROLLDOWN_FILE_URL_uyxRyhxw$2I5bBOwG10uUA